import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { CurrencyBadge as s } from "../../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as l } from "../../../../../utils/get-amount-with-currency-symbol.mjs";
import { useLocaleContext as m } from "../../../../../providers/use-locale-provider.mjs";
import { centsToUnits as p } from "@systemeio/ui";
import { twMerge as f, twJoin as d } from "tailwind-merge";
import x from "../../../../../ui-kit/icons/success-icon.mjs";
const v = ({ service: i, rule: e, onChange: c, isSelected: a }) => {
  const { locale: t } = m(), o = l(
    p(e.price),
    e.currency,
    t
  );
  return /* @__PURE__ */ n("label", { className: "relative flex cursor-pointer items-center gap-2", children: [
    /* @__PURE__ */ r(
      "input",
      {
        className: f(
          "border-fill-primary h-[20px] w-[20px] rounded-full border-2 outline-hidden",
          a ? "bg-background-secondary" : "bg-transparent",
          "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
        ),
        checked: a,
        value: e.id,
        onChange: () => {
          c({
            ruleId: e.id,
            currency: e.currency,
            price: e.price
          });
        },
        type: "radio"
      }
    ),
    /* @__PURE__ */ r(x, { className: d(!a && "fill-transparent") }),
    /* @__PURE__ */ r("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: /* @__PURE__ */ n(
      "div",
      {
        className: "main-transition-colors flex flex-col flex-wrap gap-2 text-left text-[16px]",
        children: [
          /* @__PURE__ */ n("div", { className: "flex flex-wrap gap-1", children: [
            /* @__PURE__ */ r("span", { className: "flex shrink-0", children: i.name }),
            /* @__PURE__ */ r("span", { className: "flex shrink-0", children: e.name })
          ] }),
          e.description
        ]
      }
    ) }),
    /* @__PURE__ */ n("div", { className: "ml-auto flex items-center gap-2.5", children: [
      /* @__PURE__ */ r(s, { currency: e.currency }),
      /* @__PURE__ */ r("span", { className: "main-transition-colors text-[14px] font-semibold", children: o })
    ] })
  ] });
};
export {
  v as DefaultShipping
};
